// src/types/mediaConversion/encoding.ts

export type EncodingStageKey = "1080p" | "720p" | "480p";

export const ENCODING_STAGE_ORDER: EncodingStageKey[] = [
  "1080p",
  "720p",
  "480p",
];

export function isEncodingStageKey(
  key: string
): key is EncodingStageKey {
  return (
    key === "1080p" ||
    key === "720p" ||
    key === "480p"
  );
}
